import axios from "axios";
import { authHeader } from "./auth-header";
import { startListenUserNotAuthenticated, handleError } from "./apiHandlers";

let listenStartApiNotGetCallback = null;
const startListenStartApiNotGet = listenStartApiCallbackParam => {
  listenStartApiNotGetCallback = listenStartApiCallbackParam;
};
let listenStopApiNotGetCallback = null;
const startListenStopApiNotGet = listenStopApiCallbackParam => {
  listenStopApiNotGetCallback = listenStopApiCallbackParam;
};

const get = (url, headers = {}, config = {}, messageError404 = "") => {
  return new Promise((resolve, reject) => {
    return axios({
      method: "get",
      url,
      headers: {
        ...authHeader(),
        ...headers
      },
      ...config
    })
      .then(resolve)
      .catch(handleError(reject, messageError404));
  });
};

const post = (url, data = {}, headers = {}) => {
  return new Promise((resolve, reject) => {
    listenStartApiNotGetCallback();
    return axios({
      method: "post",
      url,
      headers: {
        ...authHeader(),
        ...headers
      },
      data
    })
      .then(resolve)
      .catch(handleError(reject))
      .finally(listenStopApiNotGetCallback);
  });
};

const put = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    listenStartApiNotGetCallback();
    return axios({
      method: "put",
      url,
      headers: authHeader(),
      data
    })
      .then(resolve)
      .catch(handleError(reject))
      .finally(listenStopApiNotGetCallback);
  });
};

const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    listenStartApiNotGetCallback();
    return axios({
      method: "patch",
      url,
      headers: authHeader(),
      data
    })
      .then(resolve)
      .catch(handleError(reject))
      .finally(listenStopApiNotGetCallback);
  });
};

const httpDelete = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    listenStartApiNotGetCallback();
    return axios({
      method: "delete",
      url,
      headers: authHeader(),
      data
    })
      .then(resolve)
      .catch(handleError(reject))
      .finally(listenStopApiNotGetCallback);
  });
};

export const api = {
  get,
  post,
  put,
  patch,
  delete: httpDelete,
  startListenUserNotAuthenticated,
  startListenStartApiNotGet,
  startListenStopApiNotGet
};
